export default "__VITE_ASSET__713a52ea__"